/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Button, Modal, Notification} from '@scuf/common';
import {injectIntl} from "react-intl";

class CorruptionModal extends React.Component {

    render() {
        const {intl} = this.props
        return (
            <React.Fragment>
                <Modal closeIcon={true} onClose={this.props.onClose} open={this.props.open} closeOnDimmerClick={false} id="loosing-data-modal">
                    <Modal.Header>
                        {intl.formatMessage({id: 'loosing.data.header'})}
                    </Modal.Header>
                    <Modal.Content>
                        <Notification
                            id = "lost-data-notification"
                            hasIcon={false}
                            title={intl.formatMessage({id: 'loosing.data.lost'})}
                            severity="information"
                        />
                    </Modal.Content>
                    <Modal.Footer>
                        <div>
                            <Button type="secondary" size="medium"
                                    content={intl.formatMessage({id: 'loosing.data.stay'})}
                                    onClick={() => this.props.onClose()} className="mobile-max-width-button"/>
                            <Button type="primary" size="medium"
                                    content={intl.formatMessage({id: 'loosing.data.leave'})}
                                    onClick={() => this.props.onContinue()} className="mobile-max-width-button"/>
                        </div>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}

export default injectIntl(CorruptionModal)